import AppIndex from './App.jsx';

function App() {
  return <AppIndex />;
}

export default App;
